import { useBoolean } from 'ahooks';
import { Col, Form, Row } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useQueryClient } from 'react-query';
import { LinkButton } from 'components/atoms/button';
import { Input } from 'components/atoms/input';
import { Modal } from 'components/atoms/modal';
import { toastService } from 'components/molecules/toast';
import {
  Container,
  Content,
  FormWithMarginTop,
} from 'components/organisms/module-settings/preferences/styled';
import { useTranslation } from 'hooks/use-translation';
import { useUser } from 'hooks/use-user';
import { useCompanyUpdateMutation } from 'queries';
import { ACCOUNT_META_DATA_QUERY_KEY } from 'queries/account';
import { logger } from 'services';
import { SettingsLabel } from '../styles';

export const CompanyNameChange = () => {
  const changeNameTitle = useTranslation('change_name');
  const saveText = useTranslation('save');

  const {
    user: {
      company: { companyName, companyId },
    },
  } = useUser();

  const [form] = Form.useForm();
  const [visible, { setTrue: openModal, setFalse: closeModal }] =
    useBoolean(false);
  const service = toastService({
    title: useTranslation('settings.organisation.company_name.success.title'),
    message: useTranslation(
      'settings.organisation.company_name.success.message',
    ),
  });

  const { mutateAsync, isLoading } = useCompanyUpdateMutation(companyId);
  const queryClient = useQueryClient();
  const handleSave = async () => {
    try {
      const values = await form.validateFields();

      await mutateAsync(values);
      await queryClient.invalidateQueries(ACCOUNT_META_DATA_QUERY_KEY);
      service.success();
      form.resetFields();
      closeModal();
    } catch (error) {
      logger.error('company update failed', { error });
    }
  };

  return (
    <Container>
      <SettingsLabel>
        <FormattedMessage id="company_name" />
      </SettingsLabel>
      <Content>
        <div>{companyName}</div>
        <LinkButton onClick={openModal}>
          <FormattedMessage id="placeholder.change" />
        </LinkButton>
        <Modal
          title={changeNameTitle}
          visible={visible}
          onOk={handleSave}
          onCancel={() => {
            form.resetFields();
            closeModal();
          }}
          okButtonProps={{ loading: isLoading }}
          okText={saveText}
        >
          <FormWithMarginTop
            form={form}
            layout="vertical"
            initialValues={{ companyName }}
          >
            <Row gutter={16}>
              <Col span="24">
                <Form.Item
                  name="companyName"
                  rules={[
                    {
                      required: true,
                      message: <FormattedMessage id="input.required" />,
                    },
                  ]}
                  label={<FormattedMessage id="company_name" />}
                >
                  <Input autoFocus placeholder="Acme Inc" />
                </Form.Item>
              </Col>
            </Row>
          </FormWithMarginTop>
        </Modal>
      </Content>
    </Container>
  );
};
